const commonStore = {
    namespaced: true,
    state : {
        searchInfo : null,
        status : '',
        mainCode : '',
        mainCodeName : ''
    },
    getters: {
        getSearchInfo (state) {
            return state.searchInfo
        },
        getStatus (state) {
            return state.status
        },
        getMainCode (state) {
            return state.mainCode
        },
        getMainCodeName (state) {
            return state.mainCodeName
        },
    },
    mutations: {
        setSearchInfo (state, payload) {
            state.searchInfo = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },
        setMainCode (state, payload) {
            state.mainCode = payload
        },
        setMainCodeName (state, payload) {
            state.mainCodeName = payload
        },
    },
    actions: {
        setSearchInfo ({commit}, payload) {
            commit('setSearchInfo', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setMainCode ({commit}, payload) {
            commit('setMainCode', payload)
        },
        setMainCodeName ({commit}, payload) {
            commit('setMainCodeName', payload)
        },
        setCommonStoreInit ({commit}) {
            commit('setSearchInfo', null);
            commit('setStatus', '');
            commit('setMainCode', '');
            commit('setMainCodeName', '');
        },
    }
}


export default commonStore